import { Outlet, useLocation } from "react-router-dom";
import "../../styles/lifecycle-page.css";

export default function LifecycleLayout() {
  const { pathname } = useLocation();
  const isIndex =
    pathname === "/employee-lifecycle" || pathname === "/employee-lifecycle/";

  return (
    <div className={`lc-root${isIndex ? "" : " lc-detail-wrap"}`}>
      <Outlet />
    </div>
  );
}
